import React from "react";
import ReactDOM from "react-dom/client";
import App from "./components/App";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import UserService from "./services/UserService";
import axios from "axios";
const serverConfig = require("./config/server.js");

// Attach Keycloak Bearer token to every outgoing axios request.
axios.interceptors.request.use((config) => {
  const token = UserService.getToken();
  if (token) {
    config.headers = config.headers || {};
    config.headers["Authorization"] = `Bearer ${token}`;
  }
  return config;
});

const renderApp = () => {
  const root = ReactDOM.createRoot(document.getElementById("root"));
  /* root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  ); */
  root.render(<App />);

  const sendHeartbeat = () => {
    const token = UserService.getToken();
    if (!token) return;
    axios.post(serverConfig.api_base_url + "heartbeat", { token }).catch(() => {});
  };
  sendHeartbeat();
  setInterval(sendHeartbeat, 30000);
};

UserService.initKeycloak(renderApp);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
